import warehouseService from "@/services/warehouse";
import restaurantService from "@/services/restaurant";

const state = () => ({
    suppliers: [],
    loading: false,
});

const mutations = {
    SET_SUPPLIERS(state, suppliers) {
        state.suppliers = suppliers;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
};

const actions = {
    /**
     * Fetches suppliers based on the logged-in user type.
     * - restaurant: GET /restaurants/{id}/suppliers (only linked suppliers)
     * - all others: GET /suppliers (all suppliers)
     */
    async fetchForUser({ commit, rootState }) {
        const user = rootState.user?.user;
        const type = user?.type;
        const restaurantId = user?.restaurants?.[0]?.id;

        commit("SET_LOADING", true);
        try {
            let data;
            console.log("fetchForUser", { type, restaurantId });
            if (type === "restaurant" && restaurantId) {
                const res = await restaurantService.getRestaurantSuppliers(restaurantId);
                data = Array.isArray(res.data) ? res.data : res.data?.data ?? [];
            } else {
                const res = await warehouseService.getSuppliers();
                data = Array.isArray(res.data) ? res.data : res.data?.data ?? [];
            }
            commit("SET_SUPPLIERS", data);
            return data;
        } catch {
            return [];
        } finally {
            commit("SET_LOADING", false);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
